import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve
} from '@angular/router';
import { Observable } from 'rxjs';
import { NectaModule } from '../models/necta-module.model';
import { NectaModuleStore } from '../store/necta-module.store';


@Injectable({
  providedIn: 'root'
})
export class NectaModuleResolver implements Resolve<string> {
  private readonly nectaModuleStore = inject(NectaModuleStore);

  resolve(
    route: ActivatedRouteSnapshot,
  ): Observable<string> {
    const idParam = route.paramMap.get('id');
    if (!idParam) {
      throw new Error('NectaModuleResolver: id in Route fehlt');
    }
    const id = idParam;
    if (Number.isNaN(id)) {
      throw new Error('NectaModuleResolver: id ist keine gültige Zahl');
    }
    return this.nectaModuleStore.getNectaModuleUrlById(id);
  }
}
